import { useTranslate } from '@im/react-localization';
import { PresetRangePicker } from '@im/ui-lib/Calendar/PresetRangePicker';
import React, { FC } from 'react';
import { useDateTimeFormatter } from 'src/hooks/dateTimeFormatter';

interface Props {
  dateValues: {
    FromDate?: string;
    ToDate?: string;
  };
  setDateValues: (values: { FromDate: string; ToDate: string }) => void;
}
const PresetDateRangePicker: FC<Props> = ({ dateValues, setDateValues }) => {
  const translate = useTranslate();
  const formatDateTime = useDateTimeFormatter();
  type DateRange = [Date, Date];

  return (
    <PresetRangePicker
      endDate={dateValues.ToDate ? new Date(dateValues.ToDate) : undefined}
      format={(sDate, eDate) =>
        !sDate || !eDate || !dateValues.FromDate || !dateValues.ToDate
          ? translate('Common.DateRangePlaceholder')
          : `${formatDateTime(sDate)} to ${formatDateTime(eDate)}`
      }
      isPreset={true}
      onClearClick={() =>
        setDateValues({
          FromDate: '',
          ToDate: '',
        })
      }
      onDateChange={(sDate, eDate) => {
        if (sDate && eDate) {
          const sortedDates = [sDate, eDate]?.sort(
            (a, b) => a.getTime() - b.getTime()
          ) as DateRange;
          setDateValues({
            FromDate: new Date(sortedDates[0]).toISOString(),
            ToDate: new Date(sortedDates[1]).toISOString(),
          });
        }
      }}
      onIntervalSelected={(obj) =>
        setDateValues({
          FromDate: new Date(obj.actualStartDate).toISOString(),
          ToDate: new Date(obj.actualEndDate).toISOString(),
        })
      }
      startDate={
        dateValues.FromDate ? new Date(dateValues.FromDate) : undefined
      }
      sx={{
        '.MuiOutlinedInput-root': {
          input: { caretColor: 'transparent', pointerEvents: 'none' },
          margin: 0,
          paddingBottom: '0 !important',
          paddingTop: '0 !important',
        },
      }}
    />
  );
};
export default PresetDateRangePicker;
